module.exports = __webpack_public_path__ + "assets/ca07bb144c8986f067385b5d3fe5f7c9.svg";